/**
 * Generates and downloads a CSV file from an array of objects.
 *
 * @param {Object[]} data - Array of row objects
 * @param {Array<{key: string, label: string, format?: function}>} columns - Column definitions
 * @param {string} filename - Download filename (without extension)
 */
export function exportToCSV(data, columns, filename) {
  if (!data || data.length === 0) return;

  const BOM = '\uFEFF';
  const separator = ';';

  const header = columns.map(c => escapeCSV(c.label)).join(separator);

  const rows = data.map(row =>
    columns.map(col => {
      let val = col.format ? col.format(row) : (row[col.key] ?? '');
      return escapeCSV(String(val));
    }).join(separator)
  );

  const csv = BOM + [header, ...rows].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function escapeCSV(value) {
  if (value == null) return '';
  const str = String(value).replace(/"/g, '""');
  return `"${str}"`;
}
